import React from 'react';
import { useDispatch } from 'react-redux';
import fileDownload from 'js-file-download';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateFormatter, smevCheckFormatter } from '../../../utils/formatters';
import { successNotification } from '../../Notifications/notificationDecorator';
import { responseLogWithNotification } from '../../../utils/utils';
import { smevCheckApplication } from '../../Application/actions';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

export default function MobileSmevChecker(props) {
  const {
    list = [],
    startCheckAction = () => {},
    loadData = () => {},
    handleClose = () => {},
    current,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const handleRunCheck = checkId => () => {
    dispatch(smevCheckApplication({ checkId })).then(() => {
      successNotification('Повторная проверка', 'Повторная проверка запущена');
    }).catch(responseLogWithNotification);
  };
  const handleRunCheckAll = () => {
    dispatch(startCheckAction(current.id)).then(() => {
      loadData();
      successNotification('Запуск проверок', 'Проверки успешно запущены');
    }).catch(responseLogWithNotification);
  };

  const columns = [
    {
      dataField: 'type',
      text: 'Проверка',
      disableSort: true,
      headerClassName: 'check-type-name',
      formatter: smevCheckFormatter,
    },
    {
      dataField: 'type',
      text: 'Поставщик информации',
      disableSort: true,
      formatter: t => (t && t.source ? t.source : ''),
    },
    // {
    //   dataField: 'response_date',
    //   text: 'Дата планового ответа',
    //   disableSort: true,
    // },
    {
      dataField: 'responded_at',
      text: 'Дата ответа',
      disableSort: true,
      formatter: dateFormatter,
    },
    {
      dataField: 'report',
      text: 'Отчет',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'report-column-data',
      formatter: () => <Icons className="grid-button" icon="paper" customIcon />,
    },
    {
      dataField: 'last_smev_log',
      text: 'Запрос',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_request, `${data.type.name}_request.xml`)} icon="xml_report" customIcon />,
    },
    {
      dataField: 'last_smev_log',
      text: 'Ответ',
      disableSort: true,
      headerClassName: 'report-column',
      dataClassName: 'reload-column-data',
      formatter: (item, data) => <Icons onClick={() => fileDownload(item.xml_response, `${data.type.name}_response.xml`)} icon="xml_report" customIcon />,
    },
    {
      dataField: 'id',
      text: 'Обновить',
      disableSort: true,
      headerClassName: 'reload-column',
      dataClassName: 'reload-column-data',
      formatter: id => <Icons onClick={handleRunCheck(id)} className="grid-button" icon="update" customIcon />,
    },
  ];

  return (
    <Dialog
      className="mobile-smev-modal"
      onClose={handleClose}
      size="xl"
      open
    >
      <DialogTitle header="Перечень запросов СМЭВ/СМЭВ СПб" />
      <DialogContent className="msm-content">
        <Grid
          emptyText={formatMessage({ id: 'empty.data' })}
          data={list}
          columns={columns}
          name="profile-list"
        />
      </DialogContent>
      <DialogFooter className="msm-footer">
        <Button variant="secondary" onClick={handleClose}>Закрыть</Button>
        <Button onClick={handleRunCheckAll}>Запустить проверки</Button>
      </DialogFooter>
    </Dialog>
  );
}
